import { useContext } from "react";
import { AppContext } from "./AppContext";
import PreviewItem from "./PreviewItem";
import PerfectScrollbar from "react-perfect-scrollbar";
import { icons } from "./icons";
import Button from "./Button";

export default function FavsBrowser() {
	let {
		setShowFavs,
		showFavs,
		setBg,
		setConfig,
		setDuration,
		setAnimationType,
	} = useContext(AppContext);

	const hasFavs = showFavs && showFavs.length > 0;

	return (
		<div className="absolute right-full top-0 flex h-full w-[800px] flex-col overflow-hidden bg-white  dark:bg-dark-900">
			<div className="flex h-12 items-center justify-between pl-4">
				My Meshes
				<div
					className="hu wu flexer cursor-pointer "
					onClick={() => setShowFavs(false)}
				>
					{icons.close}
				</div>
			</div>

			{!hasFavs ? (
				<div className="flexer mb-2 ml-2 flex-1 rounded-lg bg-dark-50 dark:bg-dark-800 ">
					<div className="text-center">
						<div className="text-primary text-lg font-bold">
							My Meshes
						</div>
						<div className="text-dark-400">
							No saved meshes yet :(
						</div>
					</div>
				</div>
			) : (
				<PerfectScrollbar>
					<div className="grid grid-cols-2 gap-4 pb-16 pl-4 pr-2">
						{showFavs &&
							showFavs.map((f, k) => {
								const { data, name } = f;
								const { duration, config, bg, animationType } =
									data;
								return (
									<div
										className="relative overflow-hidden rounded bg-white shadow-md shadow-dark-100 dark:bg-dark-800 dark:shadow-none"
										key={k}
									>
										<div className="flexer group absolute inset-0 rounded  transition-colors hover:bg-white/50 dark:hover:bg-dark-800/50 ">
											<Button
												className="-mt-10 cursor-pointer bg-accent-400 px-4 text-white opacity-0 transition-colors hover:bg-accent-500 group-hover:opacity-100"
												onClick={() => {
													setConfig(config);
													setDuration(duration);
													setBg(bg);
													setAnimationType(
														animationType
													);
													setShowFavs(false);
												}}
											>
												Load
											</Button>
										</div>
										<PreviewItem
											className="aspect-video"
											duration={duration}
											bg={bg}
											config={config}
											animationType={animationType}
										></PreviewItem>
										<div className="flex items-center justify-between p-4">
											<div className="text-primary">
												{name}
											</div>
										</div>
									</div>
								);
							})}
					</div>
				</PerfectScrollbar>
			)}
		</div>
	);
}
